import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';
import { cloneDeep } from 'lodash';

export const TemplateLoader = {
    put: async function(params: any, config: ApiRequestConfig) {
        let p = cloneDeep(params);
        if (p.preview && typeof p.preview !== 'string') {
            p.preview = p.preview.path ? p.preview.path : '';
        }
        config.apiPath = `/template/${p.id}`;
        delete p.id;
        return api.put(p, config);
    },
    post: async function(params: any, config: ApiRequestConfig) {
        let p = cloneDeep(params);
        if (p.preview && typeof p.preview !== 'string') {
            p.preview = p.preview.path ? p.preview.path : '';
        }
        config.apiPath = `/template`;
        return api.post(p, config);
    },
};